import React, { Component } from 'react';
import moment from 'moment';
import Chart from '../components/chart'
import _ from 'lodash';
import 'frappe-charts/dist/frappe-charts.min.css'
import OrderGrid from '../components/order-grid.js';
import { db } from '../firebase';

export default class Orders extends Component {

    constructor() {
        super();
        this.state = {
            symbol: null,
            orders: [],
            year: new Date().getFullYear()
        }
        this.onYearChanged = this.onYearChanged.bind(this);
    }

    onYearChanged(year) {

        this.setState({
            year: year
        })
    }


    componentDidMount() {

        this.loadYearData();
    }

    componentDidUpdate(previousProps, previousState) {

        if (previousState.year !== this.state.year) {

            this.loadYearData();
        }
    }

    async loadYearData() {

        let orders = await db.getOrdersByDate(this.state.year + "-01-01", this.state.year + "-12-31");
        orders = orders.filter(a => a).map((p_data) => {

            if (p_data) {

                p_data.date = new Date(p_data.date);
                //p_data.date.setHours(0, 0, 0);
                let timestamp = p_data.date.getTime() / 1000;
                timestamp = Math.floor(timestamp - (timestamp % 86400)).toFixed(1);
                p_data.timestamp = parseInt(timestamp);
                return p_data;
            }
        });
        this.setState({
            orders: orders
        });
    }


    render() {


        let heatmap_data = {};
        let start_date = new Date((this.state.year), 0, 1);
        let end_date = new Date((this.state.year), 11, 31);

        let daily_summary = _.groupBy(this.state.orders, "timestamp");
        Object.keys(daily_summary).forEach(key => {

            heatmap_data[key] = daily_summary[key].length;
        });

        let now_year = new Date().getFullYear();
        let year_options = [now_year, now_year - 1, now_year - 2, now_year - 3];
        let current_year = this.state.year;
        let onYearChanged = this.onYearChanged;
        return (

            <div className="ss-container-stacked ss-page">
                <nav className="navbar is-transparent ss-fixed-row" style={{ height: "72px", borderBottom: "1px solid #dbdbdb" }}>
                    <div class="navbar-brand">
                        <a class="navbar-item">
                            <img src="https://www.iconexperience.com/_img/g_collection_png/standard/512x512/spreadsheet.png" />
                        </a>
                    </div>
                    <div className="navbar-start">
                        <div className="navbar-item">
                            <div>
                                <p className="title is-4"><i className="fa fa-list" style={{ marginRight: "0.75em" }}></i>Orders</p>
                            </div>
                        </div>
                    </div>
                </nav>
                <section class="section  ss-container-stacked ss-fluid-row" style={{ backgroundColor: "hsl(0, 0%, 96%)" }}>
                    <div className="card ss-fixed-row">
                        <div class="tabs is-large">
                            <ul>
                                {year_options.map(function (c_year) {

                                    return (<li className={c_year === current_year ? 'is-active' : ''}><a onClick={() => onYearChanged(c_year)} >{c_year}</a></li>)
                                })}
                            </ul>
                        </div>
                        <div style={{ textAlign: "center" }}>
                            <Chart
                                type='heatmap'
                                legend_scale={[0, 1, 2, 4, 5]}
                                data={heatmap_data}
                                height={200}
                                start={start_date}
                                end={end_date}
                                discrete_domain={0}
                                legend_colors={['#ebedf0', '#fdf436', '#ffc700', '#ff9100', '#06001c']}
                            /> </div>
                    </div>
                    <div className="card ss-fluid-row">
                        <OrderGrid order_data={this.state.orders} />
                    </div>
                </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/orders.js